import createSetCurrentSailing from './setCurrentBooking';
import { currentSailingVar } from '../reactiveVariables';

const setCurrentSailing = createSetCurrentSailing(currentSailingVar);

export default setCurrentSailing;
